import {
  DeliveryConfigurationUi,
  WeekDayDeliveryUi,
} from '@/components/Seller/SellerProfile/SalesAndDelivery/DeliveryConfiguration/DeliveryConfigurationUi';
import {
  SellerDeliverySchedulesResponse,
  SellerSettingsResponse,
} from '@/data/api/model/sellers/SellersDto';
import dayjs from 'dayjs';
import { produce } from 'immer';

export function sellerSettingsResponseToDeliveryConfigurationUi(
  currentState: DeliveryConfigurationUi,
  input: SellerSettingsResponse
): DeliveryConfigurationUi {
  return produce(currentState, (draft) => {
    const nextAvailableDeliveryTime =
      input.delivery_details?.next_available_delivery_time ?? '';
    const nextAvailableDeliveryTimeValidOption =
      nextAvailableDeliveryTime &&
      currentState.timePeriods.some(
        (period) => period.value === nextAvailableDeliveryTime
      );
    if (nextAvailableDeliveryTimeValidOption) {
      draft.timePeriodSelected = nextAvailableDeliveryTime;
    }

    const cutoffTime = input.delivery_details?.next_day_delivery_time_cutoff
      ? dayjs(input.delivery_details.next_day_delivery_time_cutoff, 'HH:mm')
      : null;
    draft.nextDayCutOffTime = cutoffTime?.isValid() ? cutoffTime : null;
    draft.deliveryDays =
      input.seller_delivery_schedulers?.map((day) =>
        sellerDeliverySchedulesResponseToSellerDeliveryDay(day)
      ) ?? [];

    draft.cancelDisabled = true;
    draft.saveDisabled = true;
  });
}

function sellerDeliverySchedulesResponseToSellerDeliveryDay(
  sellerDeliverySchedulesResponse: SellerDeliverySchedulesResponse
): WeekDayDeliveryUi {
  if (
    sellerDeliverySchedulesResponse.delivery_scheduler_time_slots.length === 0
  )
    throw Error('no time slot');
  if (
    !sellerDeliverySchedulesResponse.delivery_scheduler_time_slots[0]
      .delivery_day_id
  ) {
    throw Error('no delivery day id');
  }

  const firstTimeSlot =
    sellerDeliverySchedulesResponse.delivery_scheduler_time_slots[0];

  const minDeliveryTime = dayjs(firstTimeSlot.start_time, 'HH:mm');
  const maxDeliveryTime = dayjs(firstTimeSlot.end_time, 'HH:mm');

  const enabled = firstTimeSlot.is_active;

  return {
    dayId: firstTimeSlot.delivery_day_id,
    dayName: sellerDeliverySchedulesResponse.delivery_day_name,
    enabled,
    minDeliveryTime: minDeliveryTime.isValid() ? minDeliveryTime : null,
    maxDeliveryTime: maxDeliveryTime.isValid() ? maxDeliveryTime : null,
  };
}
